// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sJxsi","actions":"styles_actions__vNpMh","actions_btn":"styles_actions_btn__NKqwP"};